/**
 * Birthdays (system category 14) looks like a category on the dashboard but
 * is not one to anything that FILES documents. It has its own screen inside
 * (features/Birthdays), a dedicated add flow, and must never be offered as a
 * destination - so it is filtered out of:
 *
 *   1. the upload flow's category picker (UploadDocument/index.tsx)
 *   2. smart-scan category suggestions (FastScanLoader's buildScanCategories)
 *   3. the move/change-category picker (ViewCategory's moveCategoryOptions)
 *
 * It deliberately REMAINS in: the dashboard grid (it should look like any
 * other tile), search filter chips (filtering BY birthdays is legitimate),
 * and every data-level list (old clients, sharing, and id -> name lookups
 * for docs already in the category all need it present).
 *
 * If you add a new picker or suggestion surface, filter it here-style with
 * excludeBirthdays rather than a bare id compare: custom categories can also
 * carry id 14, so identity is always the (id, is_custom) pair.
 */

export const BIRTHDAYS_CATEGORY_ID = 14;

export const isBirthdaysCategory = (id: number, isCustom: boolean): boolean => (
  !isCustom && Number(id) === BIRTHDAYS_CATEGORY_ID
);

export const excludeBirthdays = <T extends { id: number; is_custom?: boolean }>(
  list: T[],
): T[] => list.filter((c) => !isBirthdaysCategory(c.id, c.is_custom || false));
